import React from 'react';
import './Footer.css';

const currentYear = new Date().getFullYear();

function Footer() {
  return (
    <footer className='footer-container'>
      <div className='footer-content'>
        <div className='footer-column'>
          <h4>Oficinas</h4>
          <div className='footer-location'>
            <h5>Panamá</h5>
            <p>BellaVista, Calle María Icaza<br />
              Edificio Proconsa 1 Oficina 5C<br />
              +507 391-4683</p>
          </div>
          <div className='footer-location'>
            <h5>Miami – USA</h5>
            <p>2702 NW 112 Avenue<br />
              Doral FL, 33172<br />
              (786) 605-0280</p>
          </div>
        </div>

        <div className='footer-column'>
          <h4>¿Cómo podemos ayudarle?</h4>
          <ul>
            <li>Soluciones en la nube</li>
            <li>Office 365</li>
            <li>Análisis de Seguridad</li>
            <li>Software financiero</li>
          </ul>
        </div>

        <div className='footer-column'>
          <h4>Pruebe nuestros productos</h4>
          <ul>
            <li>Sophos Intercept X Advance</li>
            <li>Kerio Control</li>
            <li>Kerio Connect</li>
            <li>GFI LanGuard</li>
          </ul>
        </div>

        <div className='footer-column'>
          <h4>Asistencia remota inmediata</h4>
          <a href='https://898.tv/rapidotekins10' target='_blank' rel='noreferrer'>
            <img src='/images/bleuwire-teamviewer-logo.png' alt='TeamViewer' className='footer-logo' />
          </a>
          <div className='footer-contact'>
            <span>Email</span>
            <a href='mailto:soporte@tekins.com'>soporte@tekins.com</a>
          </div>
        </div>
      </div>

      <div className='footer-bottom'>
        <p>© {currentYear} Tekins. Haciendo las cosas simples.</p>
      </div>
    </footer>
  );
}

export default Footer;
